import { render, staticRenderFns } from "./RsaPazienteSospensioneAdiListComponent.vue?vue&type=template&id=598f308c&scoped=true"
import script from "./RsaPazienteSospensioneAdiListComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteSospensioneAdiListComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaPazienteSospensioneAdiListComponent.vue?vue&type=style&index=0&id=598f308c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598f308c",
  null
  
)

export default component.exports